<template>
  <div>
    <v-footer
      class="d-flex align-center justify-center ga-2 flex-wrap flex-grow-1 py-3"
      color="surface-light"
    >
      <v-btn
        v-for="(item, i) in items"
        :to="item.href"
        :key="i"
        :prepend-icon="item.icon"
        variant="text"
        rounded
        >{{ item.title }}</v-btn
      >

      <div class="w-100 text-center">
        <h2>ติดต่อเรา</h2>
            <p>📧 อีเมล: v89tech@v89tech.com</p>
            <p>📞 โทร: 099-491-6445</p>
        <v-icon>mdi-copyright</v-icon> CopyRight {{ new Date().getFullYear() }} — <strong>V89 Technology</strong>
      </div>
    </v-footer>
  </div>
</template>

<script>
import { homeItems } from "../router/linkScript";
export default {
    data: () => ({

    items: homeItems,

  }),

}
</script>

<style>

</style>